import { atom } from "jotai";

export type ShipmentLockState = {
	/** True when another user holds the edit lock, so the page is read-only. */
	isLockedByOther: boolean;
	/** True while a force-unlock (release + re-acquire) request is in flight. */
	isForcingUnlock: boolean;
	/** True once the initial lock attempt has resolved. */
	isResolved: boolean;
	/** True when the current user currently holds the lock. */
	hasLock: boolean;
	/** True after the current user force-unlocked and re-acquired the lock. */
	wasForceUnlocked: boolean;
};

export const initialShipmentLockState: ShipmentLockState = {
	isLockedByOther: false,
	isForcingUnlock: false,
	isResolved: false,
	hasLock: false,
	wasForceUnlocked: false,
};

/**
 * Lock state for the shipment currently open on the shipment page. Only one
 * shipment page is mounted at a time, so a single atom is sufficient; the
 * manager hook resets it on unmount. Reading it lets any component on the page
 * observe the lock status without prop drilling.
 */
export const shipmentLockAtom = atom<ShipmentLockState>(
	initialShipmentLockState,
);
